import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const partnerLogos = [
  { name: 'Supernova', url: 'https://customer-assets.emergentagent.com/job_619b4d5e-f51b-467f-ae93-a95fb1e339d8/artifacts/z8mypogb_Ref-Supernova.png' },
  { name: 'Multi', url: 'https://customer-assets.emergentagent.com/job_619b4d5e-f51b-467f-ae93-a95fb1e339d8/artifacts/a5csf6j6_Ref-Multi.jpg' },
  { name: 'Immofinanz', url: 'https://customer-assets.emergentagent.com/job_619b4d5e-f51b-467f-ae93-a95fb1e339d8/artifacts/h938yshm_Ref-Immofinanz.png' },
  { name: 'JLL', url: 'https://customer-assets.emergentagent.com/job_619b4d5e-f51b-467f-ae93-a95fb1e339d8/artifacts/c3wbvai2_Ref-JLL.png' },
];

// Individual block components
const StatBlock = ({ value, label }) => (
  <div className="scroll-block flex-shrink-0 px-6 md:px-10">
    <div className="text-center">
      <div className="stat-number text-4xl md:text-5xl text-[#1a237e] mb-2">
        {value}
      </div>
      <div className="text-xs md:text-sm font-medium text-slate-500 uppercase tracking-wider whitespace-nowrap">
        {label}
      </div>
    </div>
  </div>
);

const DividerBlock = () => (
  <div className="scroll-block flex-shrink-0 px-4">
    <div className="h-12 w-px bg-slate-300" />
  </div>
);

const TrustedByBlock = ({ label }) => (
  <div className="scroll-block flex-shrink-0 px-6 md:px-10">
    <span className="stat-number text-3xl md:text-4xl text-[#1a237e] whitespace-nowrap">
      {label}
    </span>
  </div>
);

const LogoBlock = ({ name, url }) => (
  <div className="scroll-block flex-shrink-0 px-4">
    <img 
      src={url}
      alt={name}
      className="h-8 md:h-10 w-auto object-contain grayscale hover:grayscale-0 transition-all duration-300"
    />
  </div>
);

// One complete set of all blocks
const BlockSet = ({ t, keyPrefix }) => (
  <>
    <StatBlock key={`${keyPrefix}-stat1`} value="17+" label={t('stats.years')} />
    <StatBlock key={`${keyPrefix}-stat2`} value="100+" label={t('stats.projects')} />
    <StatBlock key={`${keyPrefix}-stat3`} value="25%" label={t('stats.costOptimization')} />
    <DividerBlock key={`${keyPrefix}-div`} />
    <TrustedByBlock key={`${keyPrefix}-trusted`} label={t('stats.trustedBy')} />
    {partnerLogos.map((logo, i) => (
      <LogoBlock key={`${keyPrefix}-logo-${i}`} name={logo.name} url={logo.url} />
    ))}
  </>
);

const ProofStrip = () => {
  const { t } = useLanguage();

  return (
    <section className="py-8 bg-slate-50 border-y border-slate-100 overflow-hidden">
      <div className="scroll-track">
        <div className="scroll-content">
          <BlockSet t={t} keyPrefix="set1" />
          <BlockSet t={t} keyPrefix="set2" />
          <BlockSet t={t} keyPrefix="set3" />
          <BlockSet t={t} keyPrefix="set4" />
        </div>
      </div>
    </section>
  );
};

export default ProofStrip;
